import { buildInfo } from './buildInfo';

export const environment = {
  production: true,
  buildInfo,
};
